// App information
export const APP_NAME = 'NoLicense Nearby';
export const APP_DESCRIPTION = 'License original music for your creative projects';
export const APP_COPYRIGHT = `© ${new Date().getFullYear()} NoLicense Nearby. All rights reserved.`;

// Contact information
export const CONTACT_EMAIL = 'hello@nolicensenearby.com';
export const SOCIAL_LINKS = {
  instagram: 'https://instagram.com/nolicensenearby',
  youtube: 'https://youtube.com/nolicensenearby',
  twitter: 'https://twitter.com/nolicensenearby',
  soundcloud: 'https://soundcloud.com/nolicensenearby'
};

// Navigation items
export const NAV_ITEMS = [
  { name: 'Home', path: '/' },
  { name: 'Catalog', path: '/catalog' },
  { name: 'Pricing', path: '/pricing' },
  { name: 'License Music', path: '/license' },
  { name: 'About', path: '/about' }
];

// Audio formats
export const AUDIO_FORMATS = {
  SOCIAL_MEDIA: ['MP3 (320kbps)', 'WAV (16-bit)'],
  TV: ['MP3 (320kbps)', 'WAV (24-bit)', 'Stems (Individual Tracks)'],
  FILM: ['MP3 (320kbps)', 'WAV (24-bit)', 'Stems (Individual Tracks)', 'Custom Edits']
};

// Use cases
export const USE_CASES = [
  { value: 'social_media', label: 'Social Media', description: 'Content for YouTube, TikTok, Instagram, etc.' },
  { value: 'tv', label: 'TV Shows', description: 'Television programs, series, documentaries' },
  { value: 'film', label: 'Movies', description: 'Feature films, short films, documentaries' },
  { value: 'corporate', label: 'Corporate', description: 'Business videos, presentations, ads' },
  { value: 'podcast', label: 'Podcasts', description: 'Audio or video podcasts' }
];

// Genres
export const GENRES = [
  'Electronic',
  'Hip Hop',
  'Pop',
  'Rock',
  'Ambient',
  'Corporate',
  'Cinematic',
  'Folk',
  'Jazz',
  'Classical'
];

// Moods
export const MOODS = [
  'Upbeat',
  'Relaxed',
  'Energetic',
  'Inspirational',
  'Mysterious',
  'Emotional',
  'Happy',
  'Sad',
  'Tense',
  'Peaceful'
];

// License durations
export const LICENSE_DURATIONS = [
  { value: 'one-time', label: 'One-time use' },
  { value: 'six-months', label: '6 months' },
  { value: 'one-year', label: '1 year' },
  { value: 'perpetual', label: 'Perpetual' }
];

// Project types
export const PROJECT_TYPES = [
  { value: 'social', label: 'Social Media Video' },
  { value: 'youtube', label: 'YouTube Channel' },
  { value: 'tv', label: 'TV Show' },
  { value: 'film', label: 'Film/Movie' },
  { value: 'podcast', label: 'Podcast' },
  { value: 'corporate', label: 'Corporate Video' },
  { value: 'other', label: 'Other' }
];

// Pricing tiers
export const PRICING_TIERS = {
  SOCIAL_MEDIA: {
    basePrice: 100,
    discount: 20,
    minTracks: 5
  },
  TV: {
    basePrice: 2000,
    discount: 15,
    minTracks: 3
  },
  FILM: {
    basePrice: 5000,
    discount: 10,
    minTracks: 2
  }
};

// License request statuses
export const LICENSE_STATUSES = {
  PENDING: 'pending',
  APPROVED: 'approved',
  REJECTED: 'rejected'
};

// FAQ items
export const FAQ_ITEMS = [
  {
    question: 'What rights do I get when I license a track?',
    answer: 'Your license grants you the right to use the music in your specified project type (social media, TV, film, etc.) for the duration selected. You cannot resell or redistribute the music as a standalone product. Each license is specific to the usage outlined in your request.'
  },
  {
    question: 'Can I monetize content using your music?',
    answer: 'Yes! All licenses include the right to monetize your content on platforms like YouTube, TikTok, and Instagram. You won\'t face any copyright claims or strikes when using our properly licensed music.'
  },
  {
    question: 'Do I need to credit you in my project?',
    answer: 'Credit is appreciated but not required for social media licenses. For TV and film licenses, credit is typically required in the end credits as "Music by NoBanks Nearby." The specific credit requirements will be outlined in your license agreement.'
  },
  {
    question: 'How quickly will my license request be approved?',
    answer: 'Most social media license requests are approved within 24 hours. TV and film licenses may take 1-3 business days as they require more detailed review. Our AI-powered system helps streamline the process and flags any complex requests for faster human review.'
  },
  {
    question: 'What file formats will I receive?',
    answer: 'All licenses include high-quality MP3 (320kbps) and WAV files. TV and film licenses also include professional stems (separate instrument tracks) upon request, allowing for more flexibility in your production.'
  }
];
